import { useEffect } from 'react'

import { endsWith, keys, pickBy } from 'lodash'

import { useLocation } from 'components/ReactRouterProvider/context'

// TODO confirm staleness
const { userpilot } = window
const { identify, reload, clean } = userpilot ?? {}

export const useTrackUserPilotMovement = () => {
  const location = useLocation()

  useEffect(() => {
    reload?.()
  }, [location])
}

export const login = ({ email, roles, userId, isShadow, scid, collegeFeatures, collegeName, confirmationDate }) => {
  if (userId && !!identify) {
    const staff = endsWith(email, '@scoir.com')
    identify(userId, {
      id: userId,
      isShadow: isShadow,
      staff,
      userType: 'AO',
      collegeFeatures: keys(pickBy(collegeFeatures)),
      roles: roles.filter((role) => role !== 'RoleReceiver' && role !== 'EapMember'),
      created_at: confirmationDate,
      company: {
        id: scid,
        name: collegeName,
      },
    })
  }
}

export const logout = () => {
  clean?.()
}

const userPilot = { login, logout }
export default userPilot
